module.exports = __webpack_public_path__ + "static/img/hongwai.db951a5b.png";